// SHOW_INVOICE_SUCCESS
// SHOW_INVOICE_FAIL
// SEND_INVOICE_SUCCESS
// SEND_INVOICE_FAIL

export const SHOW_INVOICE_SUCCESS ="SHOW_INVOICE_SUCCESS"
export const SHOW_INVOICE_FAIL    ="SHOW_INVOICE_FAIL"
export const SEND_INVOICE_SUCCESS ="SEND_INVOICE_SUCCESS"
export const SEND_INVOICE_FAIL    ="SEND_INVOICE_FAIL"
